export { Link2 as default } from './Link2';
